import React, {FC} from "react"

import DealListQuery, {getDealList} from "@irati/deals/apollo/query/DealList"
import {FormattedMessage} from "@irati/utils/lang"
import {getThumbnailImage} from "@irati/utils/images"
import Tag from "@irati/ui/src/Tag"
import HR from "@irati/ui/src/Layout/Hr"
import {H5} from "@irati/ui/src/Typography"
import Close from "@irati/ui/src/Close"
import Flex from "@irati/ui/src/Flex"
import {Deal, DealsTag, DealStatus} from "@irati/types"

import DescriptionModal from "../styled/DescriptionModal"
import ThumbnailImage from "../styled/ThumbnailImage"
import {TagModalList, CenteredTag} from "./styled"

interface Props {
  tag: DealsTag
  onHide: () => void
}

const TagModal: FC<Props> = ({tag, onHide}) => {
  return (
    <DescriptionModal backdrop backdropClassName="consistentBackdrop" dialogClassName="tagPopUp" show={!!tag} onHide={onHide}>
      <CenteredTag>
        <Tag name={tag.name} selected={false} onClick={() => {}} />
      </CenteredTag>
      <Close top="20px" right="20px" onClick={onHide} />
      <H5 className="text-center push--bottom">
        <FormattedMessage id="admin.components.tagModal.headerFive.tagName" values={{tagname: tag.name}} />
      </H5>
      <TagModalList>
        <DealListQuery
          variables={{
            tags: [tag.uuid],
            statuses: [DealStatus.On],
            ignoreBlacklist: false
          }}>
          {(apollo) => {
            const dealsList = getDealList(apollo)
            return (
              <>
                {dealsList.results.map((deal: Deal) => (
                  <div key={deal.uuid}>
                    <Flex alignItems="center" justifyContent="flex-start">
                      <ThumbnailImage src={getThumbnailImage(deal.thumbnailImage)} />
                      <H5>{deal.header}</H5>
                    </Flex>
                    {dealsList.results.length > 1 && <HR />}
                  </div>
                ))}
              </>
            )
          }}
        </DealListQuery>
      </TagModalList>
    </DescriptionModal>
  )
}

export default TagModal
